import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
	routes: [
		// {
		//   path: '/',
		//   name: 'HelloWorld',
		//   component: HelloWorld
		// }
		{
			path: '/',
			redirect: '/home'
		}, {
			path: '/index',
			redirect: '/home',
			name: 'Index',
			component: () => import('@/views/home'),
			children: [{ //首页
					path: '/home',
					name: 'Home',
					component: () => import('@/views/home/home'),
					meta: {
						title: '首页',
					},
				},
				{ //关于我们
					path: '/about',
					name: 'About us',
					component: () => import('@/views/home/about'),
					meta: {
						title: '关于我们',
					},
				},
				{ // 机构介绍
					path: '/about/organization',
					name: 'Who are we',
					component: () => import('@/views/home/about/organization'),
					meta: {
						title: '机构介绍',
					},
				},
				{ // 主营业务
					path: '/about/mainBusiness',
					name: 'What we do',
					component: () => import('@/views/home/about/mainBusiness'),
					meta: {
						title: '主营业务',
					},
				},
				{ // 组织架构
					path: '/about/framework',
					name: 'Structure',
					component: () => import('@/views/home/about/framework'),
					meta: {
						title: '组织架构',
					},
				},
				{ // 愿景
					path: '/about/ourwish',
					name: 'Our Vision',
					component: () => import('@/views/home/about/ourwish'),
					meta: {
						title: '愿景目标',
					},
				},
				{ //标识代码
					path: '/bsdm',
					name: 'Identification Code',
					component: () => import('@/views/home/bsdm'),
					meta: {
						title: '标识代码',
					},
				},
				{ //什么是标识代码
					path: '/bsdm/bsdmIntro',
					name: 'Introduction to Identification Code',
					component: () => import('@/views/home/bsdm/bsdmIntro'),
					meta: {
						title: '标识代码介绍',
					},
				},
				{ //应用场景
					path: '/bsdm/applyScenario',
					name: 'Application Scenarios',
					component: () => import('@/views/home/bsdm/applyScenario'),
					meta: {
						title: '应用场景介绍',
					},
				},
				{ //价值和意义
					path: '/bsdm/worth',
					name: 'Value and Significance',
					component: () => import('@/views/home/bsdm/worth'),
					meta: {
						title: '价值和意义',
					},
				},
				{ //获取标识代码
					path: '/bsdm/getBsdm',
					name: 'Get your Identification Code',
					component: () => import('@/views/home/bsdm/getBsdm'),
					meta: {
						title: '申请标识代码',
					},
				},
				{ //标准服务
					path: '/standardService',
					name: 'STANDARDS',
					component: () => import('@/views/home/standardService'),
					meta: {
						title: '标准服务',
					},
				},
				{ //标准服务
					path: '/standardService/standardServe',
					name: 'Services for Standards',
					component: () => import('@/views/home/standardService/standardServe'),
					meta: {
						title: '标准服务',
					},
				},
				{ //价值贡献
					path: '/standardService/valueContribution',
					name: 'Beneficiary',
					component: () => import('@/views/home/standardService/valueContribution'),
					meta: {
						title: '价值贡献',
					},
				},
				{ //已发布标准
					path: '/standardService/publishedStandard',
					name: 'Published Standards',
					component: () => import('@/views/home/standardService/publishedStandard'),
					meta: {
						title: '已发布的标准',
					},
				},
				{ //新闻中心
					path: '/newsCenter',
					name: 'NEWS CENTER',
					component: () => import('@/views/home/newsCenter'),
					meta: {
						title: '新闻中心',
					}
        },
          { //新闻详情
          	path: '/newsDetails',
          	name: 'NEWSDetails',
          	component: () => import('@/views/home/newsDetails'),
          	meta: {
          		title: '新闻详情',
          	}
				},
				{ //新闻报道
					path: '/newsCenter/news',
					name: 'NEWS',
					component: () => import('@/views/home/newsCenter/news'),
					meta: {
						title: '新闻报道',
					},
				},
				{ //市场活动
					path: '/newsCenter/marketEvents',
					name: 'Events',
					component: () => import('@/views/home/newsCenter/marketEvents'),
					meta: {
						title: '市场活动',
					},
				},
				{ //加入我们
					path: '/joinUs',
					name: 'JOIN US',
					component: () => import('@/views/home/joinUs'),
					meta: {
						title: '加入我们',
					},
				},
				{ //ICa成员
					path: '/joinUs/icaMember',
					name: 'Alliance Members',
					component: () => import('@/views/home/joinUs/icaMember'),
					meta: {
						title: 'ICA 成员',
					},
				},
				{ //成员新闻
					path: '/joinUs/memberNews',
					name: 'Member news',
					component: () => import('@/views/home/joinUs/memberNews'),
					meta: {
						title: '成员新闻',
					},
				},
				{ //加入ica
					path: '/joinUs/joinICA',
					name: 'Join ICA',
					component: () => import('@/views/home/joinUs/joinICA'),
					meta: {
						title: '加入ICA',
					},
				},
				{ //ICa成员-成员列表
					path: '/joinUs/memberList',
					name: 'MemberList',
					component: () => import('@/views/home/joinUs/memberList'),
				},
			]
		},
		{ // 注册引导
			path: '/register',
			name: 'Register',
			component: () => import('@/views/admin/register')
		},
		{ // 个人成员注册
			path: '/personalRegister',
			name: 'PersonalRegister',
			component: () => import('@/views/admin/personalRegister')
		},
		{ //单位成员注册
			path: '/unitRegister',
			name: 'UnitRegister',
			component: () => import('@/views/admin/unitRegister')
		},
    { //隐私政策政策
    	path: '/privacyPolicy',
    	name: 'PrivacyPolicy',
    	component: () => import('@/views/admin/privacyPolicy')
    },
    { //cookie政策
    	path: '/cookiePolicy',
    	name: 'CookiePolicy',
    	component: () => import('@/views/admin/cookiePolicy')
    },
    { //Service Terms
    	path: '/serviceTerms',
    	name: 'ServiceTerms',
    	component: () => import('@/views/admin/serviceTerms')
    },
		{ // 注册引导
			path: '/registerSuccess',
			name: 'RegisterSuccess',
			component: () => import('@/views/admin/registerSuccess')
		},
		{ // 找回密码
			path: '/findPaw',
			name: 'FindPaw',
			component: () => import('@/views/admin/findPaw')
		},
		{ // 找回密码
			path: '/resetPaw',
			name: 'ResetPaw',
			component: () => import('@/views/admin/resetPaw')
		},
		{
			path: '/login',
			name: 'Login',
			component: () => import('@/views/admin/login')
		},
    { // 邮件激活状态
    	path: '/jhState',
    	name: 'jhState',
    	component: () => import('@/views/admin/jhState')
    },
		{ // 登录后状态判断
			path: '/accountState',
			name: 'AccountState',
			component: () => import('@/views/admin/accountState')
		}, { // 修改注册信息
			path: '/modifyRegister',
			name: 'ModifyRegister',
			component: () => import('@/views/admin/modifyRegister')
		}, { // 提交成员申请
			path: '/memberApply',
			name: 'MemberApply',
			component: () => import('@/views/admin/memberApply')
		}, { // 成员资料审核
			path: '/memberAudit',
			name: 'MemberAudit',
			component: () => import('@/views/admin/memberAudit')
		}, { // 申请缴费
			path: '/applyPay',
			name: 'ApplyPay',
			component: () => import('@/views/admin/applyPay')
		}, { // 申请状态
			path: '/applyState',
			name: 'applyState',
			component: () => import('@/views/admin/applyState')
		}, { // 申请详情
			path: '/memberApplyInfo',
			name: 'memberApplyInfo',
			component: () => import('@/views/admin/memberApplyInfo')
		}, {
			path: '/admin',
			name: 'Admin',
			redirect: '/admin/homePage',
			component: () => import('@/views/admin/layout/layout'),
			children: [{ //后台--首页
				path: 'homePage',
				name: 'AdminHome',
				component: () => import('@/views/admin/homePage'),
			}, { //后台--成员信息
				path: 'memberInfo',
				name: 'MemberInfo',
				component: () => import('@/views/admin/memberInfo'),
			},{ //后台--成员证书
				path: 'memberCertification',
				name: 'MemberCertification',
				component: () => import('@/views/admin/memberCertification'),
			}, { //后台--会议活动
				path: 'meetingEvent',
				name: 'MeetingEvent',
				component: () => import('@/views/admin/meetingEvent'),
			}, { //后台--会议活动详情
				path: 'meetingDetail',
				name: 'MeetingDetail',
				component: () => import('@/views/admin/meetingDetail'),
			}, { //后台--我的行程
				path: 'mySchedule',
				name: 'MySchedule',
				component: () => import('@/views/admin/mySchedule'),
			}, { //后台--业务合作
				path: 'businessCooperation',
				name: 'BusinessCooperation',
				component: () => import('@/views/admin/businessCooperation'),
			}, { //后台--业务合作-合作申请
				path: 'cooperationApply',
				name: 'CooperationApply',
				component: () => import('@/views/admin/cooperationApply'),
			}, { //后台--业务合作-合作申请详情
				path: 'applyDetails',
				name: 'ApplyDetails',
				component: () => import('@/views/admin/applyDetails'),
			}, { // 续费第一步
				path: '/XfStepOne',
				name: 'XfStepOne',
				component: () => import('@/views/admin/XfStepOne')
			}, { // 续费第二步
				path: '/xfPay',
				name: 'XfPay',
				component: () => import('@/views/admin/xfPay')
			}, { //后台--联系客服
				path: 'contact',
				name: 'Contact',
				component: () => import('@/views/admin/contact'),
			}, { //后台--修改密码
				path: 'modifyPaw',
				name: 'ModifyPaw',
				component: () => import('@/views/admin/modifyPaw'),
			}, ]
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js